import { createSlice } from "@reduxjs/toolkit";

const RequestDotSlice= createSlice({
  name: "request",
  initialState: {
    requestDot: true,
  },
  reducers: {
    changeRequestDotTrue: (state, action) => {
      state.requestDot=true; // Add document ID
    },
    changeRequestDotFalse: (state) => {
      state.requestDot = false; // Reset state to an empty array
    },
  },
});

export const { changeRequestDotTrue, changeRequestDotFalse } = RequestDotSlice.actions;

export default RequestDotSlice.reducer;
